import { render, staticRenderFns } from "./TechSupport.vue?vue&type=template&id=9b41c084&"
import script from "./TechSupport.vue?vue&type=script&lang=js&"
export * from "./TechSupport.vue?vue&type=script&lang=js&"
import style0 from "./TechSupport.vue?vue&type=style&index=0&id=9b41c084&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports